import { NbDialogService } from "@nebular/theme";
import { EImportacaoType } from "../components/table/EImportacaoType";
import { getDialogCancel } from "./get-dialog-cancel";
import { ILoteDetalhes } from "../dto/ILoteDetalhes";
import { NgxSpinnerService } from "ngx-spinner";
import { HttpService } from "../../services/http/http-client.service";
import { NotificationsService } from "angular2-notifications";
import { ActivatedRoute, Router } from "@angular/router";

export default function cancelarImportacaoLote(
  dialogService: NbDialogService,
  spinnerService: NgxSpinnerService,
  notifications: NotificationsService,
  router: Router,
  http: HttpService,
  loteDetalhes: ILoteDetalhes,
  importacaoType: EImportacaoType
) {
  getDialogCancel(dialogService, loteDetalhes, importacaoType, (result) => {
    spinnerService.show();
    if (result) {
      let urlDelete: string;
      let urlSuccess: string;
      let tipo: string;
      if (importacaoType === EImportacaoType.FUNCIONARIO) {
        urlDelete = `/importacao-funcionario/${loteDetalhes.id}`;
        urlSuccess = `/pages/${router.url.split("/")[2]}/importacao-lote`;
        tipo = "Importação";
      } else {
        urlDelete = `/importacao-carga/${loteDetalhes.id}`;
        urlSuccess = `/pages/gestao-saldo/importacao-carga-lote`;
        tipo = "Carga";
      }

      http.doDelete(
        urlDelete,
        (_response) => {
          spinnerService.hide();
          notifications.success(`${tipo} cancelada com sucesso!`);
          router.navigate([urlSuccess]);
        },
        (_error) => {
          spinnerService.hide();
          notifications.error(`Erro ao cancelar ${tipo.toLowerCase()}!`);
        }
      );
    } else {
      spinnerService.hide();
    }
  });
}
